import React from 'react'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import Button from '../../common/components/Button'

import IncidentDate from '../../incidents/components/IncidentDate'

import { usePost } from '../hooks'
import { CommentEditor } from './CommentEditor'

import styles from './Post.module.css'

const Post = () => {
  const { postId } = useParams()
  const [{ response: post, isLoading }, { refresh }] = usePost(postId)

  if (!postId || !post) return null

  return (
    <div className={styles.post}>
      {/* <Link to="/sitrep"> */}
      <Button
        text={
          <h4 style={{ margin: 0 }}>
            <i className="fas fa-arrow-left"></i> Back To Reports
          </h4>
        }
        onClick={() => window.history.back()}
      />
      {/* </Link> */}

      <div className={styles.center}>
        <h2>
          {post.esf} {post.subject}
        </h2>
        <span>
          {post.author} |{' '}
          <IncidentDate date={post.postedDate} style={styles.inline} />
        </span>
      </div>
      <Section heading="Current Status">{post.currentStatus}</Section>
      <Section heading="Limitations/Obstacles">{post.limitations}</Section>
      <Section heading="Future Concerns">{post.futureConcerns}</Section>
      <Section heading="Additional Information">{post.additionalInfo}</Section>
      {post.comments.length !== 0 && <Comments comments={post.comments} />}
      <CommentEditor postId={post.id} refresh={refresh} />
    </div>
  )
}

const Section = ({ heading, children }) => {
  if (children)
    return (
      <section>
        <h4>{heading}</h4>
        <div>{children}</div>
      </section>
    )
  return null
}

const Comments = ({ comments }) => {
  return (
    <Section heading="Comments">
      {comments.map((comment) => (
        <Comment comment={comment} key={comment.id} />
      ))}
    </Section>
  )
}

const Comment = ({ comment }) => (
  <div style={{ margin: '15px 0' }}>
    <div className={styles.comment}>
      <div>{comment.text}</div>
      <div className={styles.commentAuthor}>
        by {comment.author},{' '}
        <IncidentDate date={comment.createdDate} style={styles.inline} />
      </div>
    </div>
  </div>
)

export default Post
